export enum ActivityLevel {
    Client = 1,
    Product = 2,
    Case = 3,
    PortalDashboard = 4,
}
